import React from "react";

const Emails = () => {
  const email = "foo@bar.baz"; // Define email
  const subject = "Hello & Welcome"; // Define subject
  const body = "Hello world!"; // Define body

  const handleClick = (e) => {
    e.preventDefault();
    const outlookUrl = `outlook:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`;
    window.location.href = outlookUrl;
  };

  return (
    <div className="p-4 text-xl font-normal">
      <h2>Emails</h2>

      <button className="p-4 bg-blue-500 text-white rounded" onClick={handleClick}>
        Email to Outlook

      <a
        href={`mailto:${email}?subject=${encodeURIComponent(subject)}&body=${encodeURIComponent(body)}`}
        className="block mt-4 text-blue-600 underline"
        >
        Open in Default Email Client
      </a>
        </button>
    </div>
  );
};

export default Emails;
